import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import common from './modules/common'
import tracking from './modules/tracking'
import orders from './modules/orders'
import address from './modules/address'
import split from './modules/split'
import invoice from './modules/invoice'
import group from './modules/group'
import selfServes from './modules/selfServes'
import ssAddress from './modules/ssAddress'
import ssOrder from './modules/ssOrder'
import ssProducts from './modules/ssProducts'
import adminOrder from './modules/admin/order'
import adminReports from './modules/admin/reports'
import adminFilters from './modules/admin/filters'
import adminSettingsDepartments from './modules/admin/settingsDepartments'
import adminLibraries from './modules/admin/libraries'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    common,
    tracking,
    orders,
    address,
    split,
    invoice,
    group,
    selfServes,
    ssAddress,
    ssOrder,
    ssProducts,
    adminOrder,
    adminReports,
    adminFilters,
    adminSettingsDepartments,
    ...adminLibraries,
  },
})
